<script>
	import ActionButton from './components/ActionButton.svelte';
	import PlaygroundFeatureList from './components/PlaygroundFeatureList.svelte';
	import PlaygroundPhotoGallery from './components/PlaygroundPhotoGallery.svelte';
	import PopupHeader from './components/PopupHeader.svelte';
	import ApiClient from '../scripts/apiclient';
	import { createActionRunner } from '../scripts/ActionRunner';
	import { keyScope } from '../scripts/keyboard';

	const { busy, run } = createActionRunner();

	export let playground;

	$: description = playground && playground.description ? playground.description.replaceAll('\n', '<br/>') : null;

	/**
	 * Function called when the edit button is clicked
	 */
	export let edit;

	/**
	 * Function called when the move button is clicked
	 */
	export let move;

	/**
	 * Function to close the popup.
	 */
	export let close;

	/**
	 * Archive the playground.
	 */
	const archive = run(() => {
		if (!confirm('Arkivera lekplatsen?')) {
			return;
		}

		return ApiClient.setPlaygroundState(playground, 'removed').then(close);
	});

	/**
	 * Opens the edit dialog, unless the popup is busy archiving the playground.
	 */
	function startEdit() {
		if ($busy) {
			return;
		}

		edit();
	}

	keyScope({ Enter: startEdit }, { modal: true });
</script>

<div style="width:100%; height: 100%;">
	<PopupHeader {playground} />
	{#if description}
		<p>{@html description}</p>
	{/if}

	{#if playground.food}
		<p class="tight">🍽 Mat: {playground.food}</p>
	{/if}

	{#if playground.toilet}
		<p class="tight">🚽 Toalett: {playground.toilet}</p>
	{/if}

	{#if playground.directions}
		<p class="tight">🚌 Ta sig hit: {playground.directions}</p>
	{/if}

	{#if playground.parking}
		<p class="tight">🅿️ Parkering: {playground.parking}</p>
	{/if}

	{#if playground.recommended}
		<p class="recommended">⭐ Rekommenderad</p>
	{/if}

	<div class="list-wrapper">
		<PlaygroundFeatureList features={playground ? playground.features : null} showHeadline="true" />
	</div>

	{#if playground.operator}
		<p>Lekplatsen drivs av {playground.operator.name}.</p>
	{/if}

	{#if playground.url}
		<p><a href={playground.url} title={playground.url} target="_blank">Läs mer här</a></p>
	{/if}

	<PlaygroundPhotoGallery {playground} />

	<div class="button-wrapper-wrapper">
		<ActionButton {busy} action={archive} variant="btn-danger" title="Arkiverar lekplatsen så att den inte längre syns på kartan">
			<span class="fa fa-trash-o" aria-hidden="true" />
		</ActionButton>

		<div class="button-wrapper">
			<ActionButton {busy} action={move} variant="btn-secondary">Flytta</ActionButton>
			<ActionButton {busy} action={startEdit}>Redigera</ActionButton>
		</div>
		<div class="clearfix" />
	</div>
</div>

<style>
	.list-wrapper {
		margin: 10px 0 7px 0;
	}

	.button-wrapper-wrapper {
		margin-top: 15px;
	}

	.button-wrapper {
		text-align: right;
		float: right;
	}

	/* Global, since the archive button lives in its own component */
	.button-wrapper-wrapper :global(.btn-danger) {
		float: left;
	}

	p.tight {
		margin: 5px 0;
	}
</style>
